/**
 * The frozen icon set. A package may only name an icon that appears here, so a
 * design cannot pull an arbitrary glyph (or an arbitrary import) into a page.
 */

import {
  AlertCircle, Bed, Calendar, CalendarPlus, Camera, CheckCircle2, ChevronDown, Clock,
  CreditCard, Flower, Gift, Heart, Leaf, Mail, MapPin, Moon, Music, Phone, Plus,
  Share2, Sparkles, Star, Sun, Users, Utensils, X,
  type LucideIcon,
} from "lucide-react";

export const ICONS: Record<string, LucideIcon> = {
  "alert-circle": AlertCircle,
  bed: Bed,
  calendar: Calendar,
  "calendar-plus": CalendarPlus,
  camera: Camera,
  "check-circle-2": CheckCircle2,
  "chevron-down": ChevronDown,
  clock: Clock,
  "credit-card": CreditCard,
  flower: Flower,
  gift: Gift,
  heart: Heart,
  leaf: Leaf,
  mail: Mail,
  "map-pin": MapPin,
  moon: Moon,
  music: Music,
  phone: Phone,
  plus: Plus,
  "share-2": Share2,
  sparkles: Sparkles,
  star: Star,
  sun: Sun,
  users: Users,
  utensils: Utensils,
  x: X,
};

export const ICON_NAMES = Object.keys(ICONS);
